'use strict';


module.exports = {
	css: require('./lib/css'),
	events: require('./lib/events'),
	Storage: require('./lib/storage')
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/browserlib/index.js
 ** module id = 17
 ** module chunks = 0
 **/